import useCurrentUser from './useCurrentUser';

const useIsAdmin = () => {
  const user = useCurrentUser();
  const isAdmin = !!user?.isAdmin;
  return isAdmin;
};

export default useIsAdmin;
